export {checkboxStyle}

	const checkboxStyle = () => {
		$( '.wpcf7-list-item > label, .checkbox-field > label' ).
			on( 'click', function() {
				let checkbox = $( this ).find( 'input[type="checkbox"]' );
				checkbox.prop( 'checked', !checkbox.prop( 'checked' ) );
				if (checkbox.prop( 'checked' ) === true) {
					$( this ).addClass( 'checked' );
				} else {
					$( this ).removeClass( 'checked' );
				}

				let radio = $( this ).
					find( 'input[type="radio"]' ).
					closest( '.wpcf7-radio' ).
					find( 'input[type="radio"]' );

				radio.each( function() {
					$( this ).closest( 'label' ).removeClass( 'checked' );
				} );

				if ($( this ).find( 'input[type="radio"]' ).prop( 'checked' ) ===
					true) {
					$( this ).addClass( 'checked' );
				}
			} );
	}
